import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import CheminPage from './pages/Chemin/CheminPage';
import CeramistePage from './pages/Ceramiste/CeramistePage';
import SubPageBols from './pages/Ceramiste/SubPageBols';
import PoetePage from './pages/Poete/PoetePage';
import TransmissionPage from './pages/Transmission/TransmissionPage';
import VeilleuseDetail from './pages/Poete/VeilleuseDetail';
import './styles/app.scss';
import SidebarMenu from './components/SidebarMenu';
import BolDetailsPage from './pages/Ceramiste/BolDetailsPage';
import SubPageChawan from './pages/Ceramiste/SubPageChawans';
import { LanguageProvider } from './components/LanguageContext';
import PageTransition from './components/PageTransition';
import Home from './pages/Home/Home';
import SubPageChemin from './pages/Chemin/SubPage';
import SubPageExpositions from './pages/Chemin/SubPageExposition';
import ParutionsDetail from './pages/Poete/ParutionsDetail';
import InfoPage from './pages/Info/InfoPage';
import AOS from 'aos';
import 'aos/dist/aos.css';
function App() {
  // const [introFinished, setIntroFinished] = useState(false);

  // const handleIntroAnimationEnd = () => {
  //   setIntroFinished(true);
  // };

  useEffect(() => {
    AOS.init({
      duration: 100,
      easing: 'ease-out-cubic',
      offset: 30,
      once: true,
      mirror: false,
      startEvent: 'DOMContentLoaded',
      animatedClassName: 'aos-animate',
      useClassNames: false,
      disableMutationObserver: false,
      throttleDelay: 99,
      debounceDelay: 50
    });
  }, []);

  return (
    <HelmetProvider>
      <LanguageProvider>
        <div className="app">
          {/* {!introFinished && <IntroPage onAnimationEnd={handleIntroAnimationEnd} />} */}
          <Router>
          <SidebarMenu />
          <div className="right_content">
          <PageTransition>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/chemin" element={<CheminPage />} />
              <Route path="/chemin/:slug" element={<SubPageChemin />} />
              <Route path="/chemin/expositions/:slug" element={<SubPageExpositions />} />
              <Route path="/Ceramiste" element={<CeramistePage />} />
              <Route path="/Ceramiste/bols" element={<SubPageBols />} />
              <Route path="/Ceramiste/chawans" element={<SubPageChawan />} />
              <Route path="/Ceramiste/bols/:slug" element={<BolDetailsPage />} />
              <Route path="/Ceramiste/chawans/:slug" element={<BolDetailsPage />} />
              <Route path="/veilleusedelieux" element={<PoetePage />} />
              <Route path="/veilleusedelieux/résidences/:slug" element={<VeilleuseDetail />} />
              <Route path="/veilleusedelieux/parutions/:slug" element={<ParutionsDetail />} />
              <Route path="/transmission" element={<TransmissionPage />} />
              <Route path="/info" element={<InfoPage />} />
            </Routes>
          </PageTransition>
          </div>
        </Router>
      </div>
    </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;